/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

export class PlatformLegalEntityAddressDto {

  uuid: string | null = null;

  owner: string | null = null;

  addressLine: string | null = null;

  city: string | null = null;

  state: string | null = null;

  postalCode: string | null = null;

  country: string | null = null;
}
